module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали банковской транзакции\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('a', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        return _vm.smartBackButton('bank-transactions')
      }
    }
  }, [_vm._v("← Назад к Банковским транзакциям")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.bank_transaction.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteBankTransaction.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить банковскую транзакцию")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Номер")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bank_transaction.number))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Сумма")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toMoney(_vm.bank_transaction.amount)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Тип операции")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bank_transaction.transaction_type))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата и время")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.bank_transaction.datetime)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Назначение")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bank_transaction.purpose))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Распознана")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bank_transaction.recognized))])])])]), _vm._v(" "), (!_vm.bank_transaction.recognized) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v("Подвязать к клиенту")]), _vm._v(" "), _c('div', [_c('select-client', {
    on: {
      "selectClient": _vm.bindToClient
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2269a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank_transaction/BankTransactionDetails.vue
// module id = 719
// module chunks = 0